import { DeviceAlertState, MetricUnit } from '@/__generated__/graphql';
import { z } from 'zod/v4';

const rangeConfigSchema = z.object({
  alertType: z.enum([DeviceAlertState.Ok, DeviceAlertState.Warning, DeviceAlertState.Critical]),
  criteria: z.literal('range'),
  modality: z.enum(['in_range', 'out_range'], { error: 'Debes seleccionar una modalidad' }),
  // timeout: z.number(),errorMap
  minimum: z.number().min(0, 'El mínimo debe ser al menos 0'),
  maximum: z.number().min(0, 'El máximo debe ser al menos 0'),
})

const thresholdConfigSchema = z.object({
  alertType: z.enum([DeviceAlertState.Ok, DeviceAlertState.Warning, DeviceAlertState.Critical]),
  criteria: z.literal('threshold'),
  modality: z.enum(['above', 'below']),
  threshold: z.number().min(0, 'El valor umbral debe ser al menos 0'),
  // timeout: z.number(),
})


const notifiableUserSchema = z.object({
  userId: z.string(),
  useWhatsapp: z.boolean(),
  useEmail: z.boolean(),
  useSms: z.boolean(),
  useAmaruLite: z.boolean(),
})

export const alertConfigurationSchema = z.object({
  deviceId: z.string().min(1, 'Debes seleccionar un dispositivo para continuar'),
  metric: z.string().min(1, 'Debes seleccionar una métrica para continuar'),
  unit: z.enum(MetricUnit),
  configurations: z.array(
    z.discriminatedUnion('criteria', [rangeConfigSchema, thresholdConfigSchema])
  ).min(1, 'Debe configurar al menos un tipo de alerta'),
  usersToNotify: z.array(notifiableUserSchema)
})

export type AlertConfigurationForm = z.infer<typeof alertConfigurationSchema>;
export type RangeConfig = z.infer<typeof rangeConfigSchema>;
export type ThresholdConfig = z.infer<typeof thresholdConfigSchema>;
export type NotifiableUser = z.infer<typeof notifiableUserSchema>;